import { render, staticRenderFns } from "./verticalMenu.vue?vue&type=template&id=76583253&"
import script from "./verticalMenu.vue?vue&type=script&lang=js&"
export * from "./verticalMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports